import { atom } from 'recoil'
import { AUTH_TOKEN } from 'lib/constants'

export const authState = atom({
  key: 'authState',
  default: { token: localStorage.getItem(AUTH_TOKEN) },
})
